// Sign-in and invitation acceptance: the only screens shown without a session.
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState, type FormEvent } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { api, errorText } from "../api/client";
import { keys } from "../app/queries";
import { first } from "../lib/format";

function Brand() {
  return (
    <div className="brand">
      <img src="/brand/govchew-logo.svg" height={36} alt="GovChew" />
    </div>
  );
}

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const client = useQueryClient();
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await api("/api/login", { method: "POST", body: { email, password } });
      await client.resetQueries();
    } catch (err) {
      setError(errorText(err));
    }
  };
  return (
    <div className="gate" id="gate">
      <form id="login-form" onSubmit={submit}>
        <Brand />
        <h1>Sign in</h1>
        <p>Government opportunities, matched to what your team does.</p>
        <label className="field">
          <span>Email</span>
          <input type="email" id="login-email" autoComplete="username" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="field">
          <span>Password</span>
          <input type="password" id="login-password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button className="btn primary">Sign in</button>
        <div className="error" id="login-error" role="alert">
          {error}
        </div>
        <p style={{ marginTop: 14, fontSize: 13, color: "var(--ink-3)" }}>Forgot your password? Ask your admin for a new sign-in link.</p>
      </form>
    </div>
  );
}

export function Invite() {
  const { token = "" } = useParams();
  const who = useQuery({
    queryKey: ["invite", token],
    queryFn: () => api<{ email: string; name: string }>(`/api/invites/${encodeURIComponent(token)}`),
    retry: false,
  });
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const client = useQueryClient();
  const navigate = useNavigate();
  if (who.isPending) return null;
  if (who.isError)
    return (
      <div className="gate" id="gate">
        <form>
          <Brand />
          <h1>Link expired</h1>
          <p>{errorText(who.error)}</p>
          <Link className="btn primary" to="/">
            Go to sign in
          </Link>
        </form>
      </div>
    );
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await api(`/api/invites/${encodeURIComponent(token)}`, { method: "POST", body: { password } });
      await client.resetQueries({ queryKey: keys.me });
      navigate("/brief", { replace: true });
    } catch (err) {
      setError(errorText(err));
    }
  };
  return (
    <div className="gate" id="gate">
      <form id="invite-form" onSubmit={submit}>
        <Brand />
        <h1>Welcome, {first(who.data.name)}</h1>
        <p>
          Choose a password for <b>{who.data.email}</b>.
        </p>
        <label className="field">
          <span>Password</span>
          <input type="password" id="invite-password" autoComplete="new-password" minLength={10} required autoFocus value={password} onChange={(e) => setPassword(e.target.value)} />
          <small>At least 10 characters.</small>
        </label>
        <button className="btn primary">Set password and continue</button>
        <div className="error" id="invite-error" role="alert">
          {error}
        </div>
      </form>
    </div>
  );
}
